import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

// Handles the edit modal for Production Machine cards.
// On edit button click: loads the edit form via Turbo Frame.
// On frame render: shows the dialog and initializes flatpickr on date inputs.
export default class extends Controller {
  static targets = ["dialog", "errors", "dateInput"]

  connect() {
    this.flatpickrInstances = []
    this.boundOnFrameRender = this.onFrameRender.bind(this)
    document.addEventListener("turbo:frame-render", this.boundOnFrameRender)
  }

  disconnect() {
    document.removeEventListener("turbo:frame-render", this.boundOnFrameRender)
    this.destroyFlatpickr()
  }

  onFrameRender(event) {
    if (event.target.id !== "production-machine-edit-modal-frame") return
    this.initFlatpickrInForm()
    if (this.hasDialogTarget) this.dialogTarget.showModal()
  }

  initFlatpickrInForm() {
    this.destroyFlatpickr()
    const appendTo = this.hasDialogTarget ? this.dialogTarget : undefined
    this.dateInputTargets.forEach((input) => {
      this.flatpickrInstances.push(flatpickr(input, {
        dateFormat: "Y-m-d",
        allowInput: true,
        disableMobile: true,
        appendTo
      }))
    })
  }

  destroyFlatpickr() {
    this.flatpickrInstances?.forEach((instance) => instance.destroy())
    this.flatpickrInstances = []
  }

  open(event) {
    const editUrl = event.currentTarget.dataset.editUrl
    if (!editUrl) return

    this.clearErrors()
    Turbo.visit(editUrl, { frame: "production-machine-edit-modal-frame" })
  }

  close() {
    if (this.hasDialogTarget) this.dialogTarget.close()
  }

  clearErrors() {
    if (this.hasErrorsTarget) {
      this.errorsTarget.textContent = ""
      this.errorsTarget.classList.add("hidden")
    }
  }
}
